import React from 'react';
import { AvTooltip, Select } from '@fabric-ui/components';
import { SortDown } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { emptyArray, iconSize } from '@fabric-ui/utils';
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { SortBy, SortDir } from '../types';

const ArrowIcon = isUp => <SortDown style={{ ...iconSize(16), transform: `rotate(${isUp ? -180 : 0}deg)` }} />;

export const SORTING_KEYS = {
  dir: 'dir',
  name: 'name',
} as const;

interface Props {
  label: string;
  selectedOption: SortBy;
  options: { title: string | number | null | undefined; value: string }[];
  onChange: (key: keyof typeof SORTING_KEYS, value: SortDir | string) => void;
}

const SelectSortingField = ({ label, selectedOption, options = emptyArray, onChange }: Props) => {
  const theme = useTheme();

  return (
    <Box sx={{ ...flex.row, gap: 1 }}>
      <Select
        muiProps={{ disableClearable: true }}
        label={label}
        size="xSmall"
        value={selectedOption?.name}
        onChange={(selectedOption: string) => onChange(SORTING_KEYS.name, selectedOption)}
        options={options}
      />
      <Box sx={{ ...flex.col, gap: '3px' }}>
        <Box sx={{ fontSize: 12, color: theme.palette.colors.neutrals[550] }}>Order</Box>
        {/* @ts-ignore */}
        <ToggleButtonGroup
          disabled={!selectedOption}
          color="white"
          size="xSmall"
          value={selectedOption?.dir || SortDir.ASC}
          onChange={(event: React.MouseEvent<HTMLElement>, value: SortDir) => onChange(SORTING_KEYS.dir, value)}
          exclusive>
          <ToggleButton value={SortDir.DESC}>
            <AvTooltip title="Descending">
              <Box sx={flex.col}>{ArrowIcon(false)}</Box>
            </AvTooltip>
          </ToggleButton>
          <ToggleButton value={SortDir.ASC}>
            <AvTooltip title="Ascending">
              <Box sx={flex.col}>{ArrowIcon(true)}</Box>
            </AvTooltip>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};
export default SelectSortingField;
